import { render, staticRenderFns } from "./ChairmanBiography.vue?vue&type=template&id=66f152c0&scoped=true&"
import script from "./ChairmanBiography.vue?vue&type=script&lang=js&"
export * from "./ChairmanBiography.vue?vue&type=script&lang=js&"
import style0 from "./ChairmanBiography.vue?vue&type=style&index=0&id=66f152c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f152c0",
  null
  
)

export default component.exports